// This is generated.  Alter it in blockGroups/searchElements/types/IncludedValueSearch.js
/* eslint-disable no-unused-vars */
const { Type } = require('@sinclair/typebox');
const { moduleRegistration } = require('@sstdev/lib_metadata-config');
module.exports = {
  asDataDictionary: function asDataDictionary(hNode, context) {
    const {
      id,
      title,
      namespace,
      relation,
      propertyName: _propertyPath,
      toggleValues,
      valueExists,
      includeUndefined,
    } = hNode;
    let propertyPath = _propertyPath.split('.');
    const propertyName = propertyPath.pop(); //pop() removes and returns the last element

    // Create TypeBox string schema with search-specific metadata
    const stringSchema = Type.String({
      'x-id': id,
      title: title,
      'x-dataType': 'string',
      'x-propertyName': propertyName,
      'x-forAction': 'filter',
      'x-toggleValues': toggleValues,
      'x-valueExists': valueExists,
      'x-includeUndefined': includeUndefined,
    });

    let partialTypeDefinition = {
      [propertyName]: stringSchema,
    };

    // If property path has nested parts (e.g., 'nested.path.property'), wrap in TypeBox objects
    if (propertyPath.length) {
      // reduceRight is a reduce function that starts from the end of the array and works its way to the beginning
      partialTypeDefinition = propertyPath.reduceRight((acc, path) => {
        return {
          [path]: Type.Object(acc, {
            'x-dataType': 'object',
            'x-propertyName': path,
            additionalProperties: true,
          }),
        };
      }, partialTypeDefinition);
    }

    let subDataDictionary = {};
    if (namespace && relation) {
      // Register foreign key to declare the relation and get proper TypeBox schema
      const properties = [propertyName];
      partialTypeDefinition = context.registerForeignKey(
        namespace,
        relation,
        properties,
        { id, title },
      );
      Object.values(partialTypeDefinition || {}).forEach((schema) => {
        if (schema && typeof schema === 'object') {
          // Preserve the filter action context for downstream required/visibility logic
          schema['x-forAction'] = 'filter';
        }
      });
    }

    return [subDataDictionary, partialTypeDefinition];
  },
};
moduleRegistration.registerHNodeType(
  'searchElements',
  'IncludedValueSearch',
  module.exports,
);
